import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xdzlkMzl1MCB7CiAgd2lkdGg6IDMzJTsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xdzlkMzl1MSB7CiAgd2lkdGg6IDUwJTsKfQ';
export var transformStackItemClass = '_1w9d39u0';
export var batteryModuleStackItemClass = '_1w9d39u1';